import {createStore,applyMiddleware} from 'redux';
import {createWrapper} from 'next-redux-wrapper';
import thunk from 'redux-thunk';
import rootReducers from './rootReducer'

// create a makeStore function
const makeStore = context => createStore(rootReducers,applyMiddleware(thunk));

// export an assembled wrapper
export default createWrapper(makeStore);